import { FC } from 'react';
import classNames from 'classnames';

import styles from './Card.module.scss';

type Elevation = 'medium' | 'none';
const isElevationSetting = (elevation: string | undefined): elevation is Elevation =>
  typeof elevation === 'string' && ['medium', 'none'].includes(elevation);
type BorderRadiusType = 'round' | 'square';
const isBorderRadiusSetting = (
  borderRadiusType: string | undefined
): borderRadiusType is BorderRadiusType =>
  typeof borderRadiusType === 'string' && ['round', 'square'].includes(borderRadiusType);

interface Props {
  borderRadiusType?: BorderRadiusType;
  elevation?: Elevation;
  shouldUsePadding?: boolean;
}

const Card: FC<Props> = ({ borderRadiusType, children, elevation, shouldUsePadding = true }) => {
  const elevationSetting = isElevationSetting(elevation) ? elevation : 'none';
  const borderRadiusSetting = isBorderRadiusSetting(borderRadiusType) ? borderRadiusType : 'round';
  return (
    <div
      className={classNames(styles.card, styles[borderRadiusSetting], {
        [styles['with-padding']]: shouldUsePadding,
        [styles[`elevation_${elevationSetting}`]]: elevation,
      })}
    >
      {children}
    </div>
  );
};

export type { Props as CardProps };
export default Card;
